import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const FinanceContainer = styled.div<{ bgUrl: string; isTablet?: boolean }>`
  height: 500px;
  width: 100%;
  margin-top: 60px;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  ${down('md')} {
    width: 100%;
    height: 450px;
    padding-left: 20px;
    margin-top: 32px;
  }

  ${({ isTablet }) =>
    isTablet &&
    `
    padding: 0 24px;
  `}

  [data-testid='finance-carousel'] {
    min-height: 128px !important;
  }
`

export const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 95%;
`
export const FinanceHeading = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 32px;
  margin-top: 60px;
  @media screen and (max-width: 962px) {
    grid-template-columns: 1fr;
  }
`
export const FinanceLogo = styled.a`
  display: inline-flex;
`
export const FinanceHeadingText = styled.div`
  color: #021141;
  font-weight: 700;
  margin-top: 24px;
  margin-bottom: 32px;
  font-size: 24px;
  line-height: 33px;
  margin-bottom: 16px;
  ${down('md')} {
    max-width: 85vw;
    margin: 10px 0px;
    font-size: 20px;
  }
`

export const SecondaryHeadingText = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  margin-top: 16px;
`

export const FinanceHeadingSubAreaWrapper = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
`

export const FinanceHeadingSubText = styled.div`
  color: #021141;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  ${down('md')} {
    margin: 10px 0px 24px 0px;
    padding-right: 10px;
  }
`

export const StoreAndQrWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100px;
  width: 250px;
`
export const StoreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0px;
  gap: 10px;
  padding-left: 10px;
`
export const QrWrapper = styled.div`
  max-width: 100px;
  max-height: 100px;
  border: 5px solid #fff;
`

export const FinanceCards = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 70px;
`

export const FinanceCard = styled.a`
  height: 146px;
  width: 173px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 0px 16px 0px 16px;
  border-radius: 8px;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  transition-duration: 0.25s;
  transition-property: box-shadow;

  ${down('md')} {
    display: flex;
    width: 100%;
    height: 118px;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex-shrink: 0;
    border-radius: 8px;
    background: var(--greys-white, #fff);
    justify-content: space-between;

    /* Elevations/Shadow 3 */
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    margin: 4px 4px 15px 4px;
    width: calc(100% - 8px);
  }

  &:hover {
    border-radius: 8px;
    background: var(--greys-white, #fff);
    /* Elevations/Shadow 3 */
    box-shadow: 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  }
`

export const FinanceCardTextWrapper = styled.div`
  ${down('md')} {
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`

export const FinanceCardText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #131717;
  line-height: 19px;
`
export const FinanceIcon = styled.div<{ isMobile: boolean }>`
  position: relative;
  width: ${(props) => (props.isMobile ? '32px' : '60px')};
  height: ${(props) => (props.isMobile ? '32px' : '60px')};

  svg {
    width: 100%;
    height: 100%;
  }
`

export const DownloadAppWrapper = styled.div<{ isMobile: boolean }>`
  background-color: #4f1bb7;
  height: 52px;
  z-index: 1;
  padding: 8px;
  border-radius: 4px;
  max-width: 100%;
  margin: 24px 23px 26px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const DownloadAppText = styled.div`
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: #fff;
`

export const DownloadBtn = styled.a`
  width: 80px;
  min-width: 65px;
  height: 36px;
  border-radius: 4px;
  background-color: #2dc44d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
`
export const DownloadText = styled.div`
  font-size: 14;
  font-weight: 700;
  line-height: 22px;
  color: #ffffff;
`
export const IconOptions = styled.div`
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px 8px 0px;
  margin-left: -8px;
`
